import {useEffect} from 'react';
import UserList from "../../../components/admin/user/UserList";
import {useDispatch, useSelector} from "react-redux";
import {getUsers, resUser} from "../../../redux/reducers/UserReducer";

function User() {
    const {currentPage, pageSize, search} = useSelector(state => state.userReducer);
    const dispatch = useDispatch();


    useEffect(() => {
        // Initialize users on component mount
        dispatch(getUsers({ page: currentPage, pageSize, search }));
    }, [dispatch]);

    return (
        <div className={"user border"}>
            <UserList />
        </div>
    );
}

export default User;